import { useIntl } from 'react-intl';
import { Box, Menu, MenuItem, Tooltip } from '@material-ui/core';
import ContainedButton from 'components/Button/ContainedButton';
import Datepicker from 'components/Datepicker';
import { HeaderTooltipText } from 'components/Table/Table.css';
import TimesheetFilterBar from './TimesheetFilterBar';
import { TimesheetBoxProps } from './types';
import { MonthPicker } from './Timesheet.css';

const TimesheetsBox = ({
  anchorEl,
  handleRemindClick,
  handleRemindClose,
  filterBar,
  date,
  onDateChange,
  onLeaderReminderClick,
  onEmployeeReminderClick,
  loading,
  handleDatepickerClearButtonClick,
}: TimesheetBoxProps) => {
  const intl = useIntl();

  const reminder = (
    <>
      <Tooltip
        title={
          <HeaderTooltipText>
            {intl.formatMessage({
              id: 'REMINDER.TOOLTIP',
            })}
          </HeaderTooltipText>
        }
        placement="bottom"
      >
        <ContainedButton
          id="reminderButton"
          onClick={handleRemindClick}
          disabled={loading}
        >
          {intl.formatMessage({ id: 'TIMESHEETS.REMINDER_BUTTON' })}
        </ContainedButton>
      </Tooltip>

      <Menu
        id="remind-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleRemindClose}
      >
        <MenuItem id="remindLeaders" onClick={onLeaderReminderClick}>
          {intl.formatMessage({ id: 'REMIND_LEADERS.BUTTON' })}
        </MenuItem>
        <MenuItem id="remindEmployees" onClick={onEmployeeReminderClick}>
          {intl.formatMessage({ id: 'REMIND_EMPLOYEES.BUTTON' })}
        </MenuItem>
      </Menu>
    </>
  );

  const monthPicker = (
    <MonthPicker>
      <Datepicker
        label={intl.formatMessage({
          id: 'TABLE_FILTER.LABEL.DATE',
        })}
        monthJumpButtons
        size="small"
        value={date}
        onChange={onDateChange}
        onClearButtonClick={handleDatepickerClearButtonClick}
        disabled={loading}
      />
    </MonthPicker>
  );

  return (
    <Box padding="1rem 0 0.5rem">
      <TimesheetFilterBar
        {...filterBar}
        leading={monthPicker}
        actions={reminder}
      />
    </Box>
  );
};

export default TimesheetsBox;
